<ng-container *mobxAutorun>
  <div
    class="alert {{ style ? 'alert-' + style : '' }}"
    role="alert"
    *ngIf="isVisible"
  >
    <button
      type="button"
      class="close"
      [title]="closeButtonTooltip"
      [attr.aria-label]="closeButtonTooltip"
      *ngIf="showCloseButton"
      (click)="hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <ng-content></ng-content>
  </div>
</ng-container>
